module.exports = __webpack_public_path__ + "img/aussen3.bd4e0c13.jpg";